<template>
    <b-container>
        <Head>
            <title>Next Gen Math - {{ title }}</title>
            <meta name="description" content="">
        </Head>
    
        <ribbon-banner>
            <h2 slot="subMenuOf" class="subMenuOf">{{ subMenuOf }}</h2>
            <h1 slot="title">{{ title }}</h1>
        </ribbon-banner>
        
        <section class="mt-5">
            <b-row>
                <b-col cols="12" md="10" class="mx-auto">
                    <p class="raised-cap">
                        Grades K-12 Common Core State Standard (CCSS) and the eight Standards for Mathematical Practice (SMP) are dynamically integrated. Each standard has multiple questions with varying DOK levels presented in multiple formats with multiple distractors including multiple-choice/multiple-response, drag and drop, fill-in-the blank and matching. All content is organized by claim, domain, cluster (target) and standard. The Eight Standards for Math Practice are assessed in performance tasks and on select questions throughout the platform.
                    </p>
                    <b-row>
                        <b-col cols="12">
                            <b-img :src="`${routes.cdn_url}/images/redesign/steamCareers/economist.svg`" class="steam-career" alt="A friendly, business-savvy lion presents their research. There is a potted plant in the background, next to a counter that with complimentary coffee."></b-img>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </section>
    </b-container>
</template>

<script>
    import RibbonBanner from '../components/RibbonBanner.vue';

    export default {
        components: {
            RibbonBanner,
        },
        data: () => ({
            subMenuOf: 'Why Next Gen Math?',
            title: 'Standards Aligned'
        })
    }
</script>

<style lang="scss" scoped>
    .subMenuOf {
        color: #888;
        font-size: 24px;
        text-align: center;
    }
</style>
